import React from 'react'
import Link from 'gatsby-link'
import logo from '../img/logo.png'

class Navbar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };

        this.onToggle = this.onToggle.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    onToggle(){
        this.setState({
            open: !this.state.open
        });
    }

    onClose(){
        this.setState({
            open: false
        });
    }

    render() {
        return (
            <nav className="navbar">
                <div className="container">
                    <div className="navbar-brand">
                        <Link className="navbar-item" to="/#si" onClick={this.onClose}>
                            <figure className="image">
                                <img src={logo} style={{width: 'initial', maxHeight :'3rem'}}/>
                            </figure>
                        </Link>
                        <span className={`navbar-burger burger ${this.state.open ? 'is-active' : '' }`}
                              data-target="mobileNav"
                              onClick={this.onToggle}>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                      </span>
                    </div>
                    <div id="mobileNav" className={`navbar-menu ${this.state.open ? 'is-active' : '' }`}>
                        <div className="navbar-end">
                            <div className="navbar-item">
                                <a>projects</a>
                                <ul>
                                    <li>
                                        <Link className="see-america-first" to="/see-america-first" onClick={this.onToggle}>
                                            see america first!
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="two-mile-high-city" to="/welcome-earthlings" onClick={this.onToggle}>
                                            welcome, earthlings</Link>
                                    </li>
                                    <li>
                                        <Link className="two-mile-high-city" to="/two-mile-high-city" onClick={this.onToggle}>
                                            the two mile high city
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="navbar-item">
                                <a>portfolio</a>
                                <ul>
                                    <li>
                                        <Link className="tourism" to="/tourism" onClick={this.onToggle}>
                                            tourism
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="travel" to="/travel" onClick={this.onToggle}>
                                            travel
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="commissioned" to="/commissioned" onClick={this.onToggle}>
                                            commissioned
                                        </Link>
                                    </li>
                                    <li>
                                        <Link className="people" to="/people" onClick={this.onToggle}>
                                            people
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="navbar-item">
                                <Link className="about" to="/about" onClick={this.onToggle}>
                                    about
                                </Link>
                            </div>
                            <div className="navbar-item">
                                <a onClick={this.onToggle}>
                                    print shop (coming soon)
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        );
    }

}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/NavbarMobile.js